

// src/components/Landing/Landing.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import memberstack from '../../memberstack';
import Navbar from '../Nav/Navbar';
import Footer from '../Footer/Footer';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import CloudDoneIcon from "@mui/icons-material/CloudDone";
import InventoryIcon from "@mui/icons-material/Inventory";


// import pharma from '../../assets/pharma.png';
import pill from '../../assets/pill (2).png';
import payhere from '../../assets/PayhereLogo.png';
import visa from '../../assets/visa.png';
import mastercard from '../../assets/MasterCardLogo.png';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Divider from '@mui/material/Divider';

import {
  MainContainer,
  HeroContainer,
  LeftSection,
  RightSection,
  Subheading,
  Heading,
  Heading2,
  Description,
  ButtonContainer,
  DemoButtonContainer,
  StyledButton,
  DemoButton,
  DemoButtonLabel,
  AboutSection,
  AboutContent,
  AboutLeft,
  AboutRight,
  FeaturesSection,
  FeaturesContent,
  FeatureGrid,
  FeatureCard,
  FeatureTitle,
  FeatureDesc,
  IconBubble,
  // CardletDesc,
  PricingSection,
  PricingContent,
  PricingLeft,
  PricingRight,
  PaymentMethods,
  PaymentCard,
  PricingCardBox,
  PricingCardTitle,
  ContactSection,
  ContactContent,
  ContactItem,
} from './styles';  // same styles you had before
import { Typography, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import TutorialHeroCard from './TutorialHeroCard';

const Landing = () => {
  const navigate = useNavigate();
  const member = useSelector((state) => state.user);

  // If user is logged in, redirect to the search page automatically.
  useEffect(() => {
    if (member && member.id) {
      navigate('/search');
    }
  }, [member, navigate]);

  return (
    <MainContainer>
      <Navbar />
      <HeroContainer id="home">
        <LeftSection>
          <Subheading>Welcome to</Subheading>
          <Heading variant="h1">MediCheck</Heading>
          <Description>
          A smarter pharmacy management system.
            <br />
          Reduce losses. Save time. Stay in control.
          </Description>
          <ButtonContainer>
            <StyledButton
              onClick={() => {
                memberstack.openModal("LOGIN").catch((error) => {
                  console.error("Login modal error:", error);
                });
              }}
            >
              Login
            </StyledButton>
            <StyledButton
              onClick={() => {
                memberstack.openModal("SIGNUP").catch((error) => {
                  console.error("Signup modal error:", error);
                });
              }}
            >
              Sign Up
            </StyledButton>
          </ButtonContainer>
          <DemoButtonContainer>
             <DemoButton
                component="a"
                href="https://demo.medicheck.lk"
                target="_blank"
                rel="noopener noreferrer"
              >
              <DemoButtonLabel>
                <AutoAwesomeIcon fontSize='small' sx={{background:'linear-gradient(135deg, #ff7a18, #ff3d81, #8f5cff)', color:'white', marginRight:'10px', borderRadius:'10px', padding:'3px'}} />
                Try FREE Demo
                </DemoButtonLabel>
            </DemoButton>
          </DemoButtonContainer>
        </LeftSection>
        <RightSection>
          {/* <img src={pharma} alt="Pharma" /> */}
          <TutorialHeroCard />
        </RightSection>
      </HeroContainer>
      <Box
        sx={{
          display: { xs: 'block', md: 'none' },
          px: 2,
          py: 3,
          backgroundColor: '#FFFBFF',
        }}
      >
        <TutorialHeroCard mobile />
      </Box>

      {/* ABOUT SECTION */}
      <AboutSection id="about">
        <AboutContent>
          <AboutLeft>
            <Heading2 variant="h2" sx={{ textAlign:{xs:'center', md:'left'}, marginBottom: 2 }}>
              About Us
            </Heading2>
            <Description>
            MediCheck is a modern pharmacy management system built specifically for pharmacies in Sri Lanka.
It helps pharmacies manage inventory, track expiry dates, monitor stock levels, and record sales, all in one easy-to-use system.

<br></br><br></br>With MediCheck, pharmacies can manage medicines and other pharmacy products, keep stock accurate, receive automatic alerts, and handle day-to-day billing. Everything is always up to date, and easy to access without relying on manual checks or multiple systems.
<br></br><br></br>Many pharmacies still depend on paper records or outdated software, or have to spend large amounts of money on complex systems that are hard to maintain. MediCheck offers a simple, affordable monthly system that works online, keeps your data safe, and lets you access everything from any device.
            {/* <br></br>After extensive consultation with healthcare professionals, including experienced doctors and professionals in the pharmaceutical industry, we've created a user-friendly app that allows quick searches of medicines, alternative brands, generics, and side effects.
            <br></br>Our goal is to support pharmacists and healthcare providers with reliable, easy-to-access medical information, enabling them to deliver confident and informed patient care. */}
               </Description>
          </AboutLeft>
          <AboutRight>
            <img src={pill} alt="About" />
          </AboutRight>
        </AboutContent>
      </AboutSection>


      {/* FEATURES SECTION */}
<FeaturesSection id="features">
  <Heading2 variant="h2" sx={{ textAlign: "center", marginBottom: 2 }}>
    Features
  </Heading2>

  <Description sx={{ textAlign: "center", maxWidth: 900, margin: "0 auto 48px" }}>
    Everything you need to manage stock, expiry, and sales in one simple system.
  </Description>

  <FeaturesContent>
    <FeatureGrid sx={{ marginTop: 0 }}>
      {/* 1) Expiry Alerts */}
      <FeatureCard>
        <IconBubble $color="red">
          <WarningAmberIcon />
        </IconBubble>

        <FeatureTitle variant="h6" sx={{ fontSize: "1.15rem" }}>
          Automatic Expiry Alerts
        </FeatureTitle>
        <Divider
          sx={{
            width: '90%',
            my: 3,
            backgroundColor: '#ededed',
          }}
        />
        <FeatureDesc sx={{ textAlign: "center", marginBottom: 0 }}>
           <ul style={{ paddingLeft: "1.2rem", margin: 0, textAlign:'left' }}>
            <li>Automatic alerts months, weeks, and days before expiry.</li>
            <li>Instantly see which batches are nearing expiry and when.</li>
            <li>Avoid fines and losses from expired medicines.</li>
            <li>Save hours of daily manual expiry checks.</li>
          </ul>
        </FeatureDesc>
      </FeatureCard>

      {/* 2) Low Stock Alerts */}
      <FeatureCard>
        <IconBubble $color="yellow">
          <RemoveCircleIcon />
        </IconBubble>

        <FeatureTitle variant="h6" sx={{ fontSize: "1.15rem" }}>
          Low Stock Alerts
        </FeatureTitle>
        <Divider
          sx={{
            width: '90%',
            my: 3,
            backgroundColor: '#ededed',
          }}
        />
        <FeatureDesc sx={{ textAlign: "center", marginBottom: 0 }}>
          <ul style={{ paddingLeft: "1.2rem", margin: 0, textAlign:'left' }}>
            <li>Automatic alerts when stock runs low.</li>
            <li>3-stage alerts so you can act early.</li>
            <li>Clearly see stock levels across your inventory.</li>
            <li>Restock on time without manual stock checks.</li>
          </ul>
        </FeatureDesc>
      </FeatureCard>

      {/* 3) Inventory Management */}
      <FeatureCard>
        <IconBubble $color="blue">
          <InventoryIcon />
        </IconBubble>

        <FeatureTitle variant="h6" sx={{ fontSize: "1.15rem" }}>
          Inventory Management
        </FeatureTitle>
        <Divider
          sx={{
            width: '90%',
            my: 3,
            backgroundColor: '#ededed',
          }}
        />
        <FeatureDesc sx={{ textAlign: "center", marginBottom: 0 }}>
          <ul style={{ paddingLeft: "1.2rem", margin: 0, textAlign:'left' }}>
            <li>Always know what’s available in your inventory.</li>
            <li>Easily view, search and filter stock with full details.</li>
            <li>Add new stock, restock items, and make adjustments quickly.</li>
            <li>Track restocks, sales, and corrections with a clear history.</li>
            
          </ul>
        </FeatureDesc>
      </FeatureCard>

      {/* 4) POS-Lite Billing */}
      <FeatureCard>
        <IconBubble $color="green">
          <PointOfSaleIcon />
        </IconBubble>

        <FeatureTitle variant="h6" sx={{ fontSize: "1.15rem" }}>
          POS
        </FeatureTitle>
        <Divider
          sx={{
            width: '90%',
            my: 3,
            backgroundColor: '#ededed',
          }}
        />
        <FeatureDesc sx={{ textAlign: "center", marginBottom: 0 }}>
          <ul style={{ paddingLeft: "1.2rem", margin: 0, textAlign:'left' }}>
            <li>Simple billing designed for pharmacies.</li>
            <li>Keeps inventory accurate without extra steps.</li>
            <li>Record sales, discounts, and bills in one flow.</li>
            <li>No heavy setup or complicated POS workflows.</li>
          </ul>
        </FeatureDesc>
      </FeatureCard>

      {/* 5) Medicine Search */}
      <FeatureCard>
        <IconBubble $color="purple">
          <SearchIcon />
        </IconBubble>

        <FeatureTitle variant="h6" sx={{ fontSize: "1.15rem" }}>
          Medicine Search
        </FeatureTitle>
         <Divider
          sx={{
            width: '90%',
            my: 3,
            backgroundColor: '#ededed',
          }}
        />
        <FeatureDesc sx={{ textAlign: "center", marginBottom: 0 }}>
          <ul style={{ paddingLeft: "1.2rem", margin: 0, textAlign:'left' }}>
            <li>Search over 5,000 NMRA-registered medicines.</li>
            <li>Easily find alternative brands for any medicine brand.</li>
            <li>View common side effects for medicines with one click.</li>
            <li>Give patients fast, confident answers at the counter.</li>
          </ul>
          </FeatureDesc>
      </FeatureCard>

      {/* 6) Cloud-Based System */}
      <FeatureCard>
        <IconBubble $color="orange">
          <CloudDoneIcon />
        </IconBubble>

        <FeatureTitle variant="h6" sx={{ fontSize: "1.15rem" }}>
          Modern, Cloud-Based System
        </FeatureTitle>
          <Divider
          sx={{
            width: '90%',
            my: 3,
            backgroundColor: '#ededed',
          }}
        />
        <FeatureDesc sx={{ textAlign: "center", marginBottom: 0 }}>
         <ul style={{ paddingLeft: "1.2rem", margin: 0, textAlign:'left' }}>
            <li>No installation or storage required.</li>
            <li>Automatic backups keep your data safe.</li>
            <li>Access your account from any device.</li>
            <li>No risk of data loss if your computer fails.</li>
          </ul>
        </FeatureDesc>
      </FeatureCard>
    </FeatureGrid>
  </FeaturesContent>
</FeaturesSection>


      {/* PRICING SECTION */}
      <PricingSection id="pricing">
      <Heading2 variant="h2" sx={{ textAlign: 'center', marginBottom: 10 }}>
            Pricing
          </Heading2>
        <PricingContent>
          {/* LEFT SIDE: SINGLE PRICING PLAN */}
          <PricingLeft>
            <PricingCardBox>
              <PricingCardTitle variant="h5" sx={{ textAlign: 'left' }}>
                Payment Plan
              </PricingCardTitle>
          <Box sx={{ textAlign: 'left', mb: 5 }}>
           <Typography variant="body1" sx={{ mb: 1 }}>
             • Full access to MediCheck
           </Typography>
           <Typography variant="body1" sx={{ mb: 1 }}>
             • Automatic expiry & low-stock alerts
           </Typography>
           <Typography variant="body1" sx={{ mb: 1 }}>
             • Inventory management
           </Typography>
           <Typography variant="body1" sx={{ mb: 1 }}>
             • POS & billing system
           </Typography>
           <Typography variant="body1" sx={{ mb: 1 }}>
             • Unlimited brand/generic lookups
           </Typography>
           <Typography variant="body1" sx={{ mb: 1 }}>
             • 100 side-effect searches per month
           </Typography>
           
           <Typography variant="body1">
             • Cancel any time
           </Typography>
         </Box>

              {/* <Typography variant="h6" sx={{ mb: 2 }}>
                3500 LKR / month
              </Typography> */}
              <Box sx={{ mb: 2 }}>


  <Typography variant="h5" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
    4,500 LKR / month
  </Typography>
</Box>

              <StyledButton
              sx={{borderRadius:'10px'}}
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}>
                Get Started
              </StyledButton>
            </PricingCardBox>
          </PricingLeft>

          {/* RIGHT SIDE: PAYMENT METHODS */}
          <PricingRight>
            <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
              Secure Payments
            </Typography>
            <Description>
              All transactions are processed through PayHere, Sri Lanka’s Central Bank-approved, PCI DSS-certified gateway. We accept payments from VISA and MasterCard.
            </Description>
            <PaymentMethods>
              <PaymentCard>
                <img src={payhere} alt="Payhere" />
              </PaymentCard>
              <PaymentCard>
                <img src={visa} alt="Visa" />
              </PaymentCard>
              <PaymentCard>
                <img src={mastercard} alt="Mastercard" />
              </PaymentCard>
            </PaymentMethods>
          </PricingRight>
        </PricingContent>
      </PricingSection>
      <ContactSection id="contact">
  <Heading2 variant="h2" sx={{ textAlign: 'center', marginBottom: 4 }}>
    Contact Us
  </Heading2>
  <ContactContent>
    <ContactItem>
      <PhoneIcon fontSize="large" sx={{ color: '#006bd6' }} />
      <Typography variant="body1" sx={{ marginLeft: 1 }}>
        +94 77 003 2167
      </Typography>
    </ContactItem>
    <ContactItem>
      <EmailIcon fontSize="large" sx={{ color: '#006bd6' }} />
      <Typography variant="body1" sx={{ marginLeft: 1 }}>
        info@medicheck.lk
      </Typography>
    </ContactItem>
  </ContactContent>
</ContactSection>
      <Footer landing />
    </MainContainer>
  );
};

export default Landing;
